import {
  CellValueChangedEvent, ColDef, ColumnMovedEvent, ColumnState, DragStoppedEvent, FilterChangedEvent,
  GridApi, GridOptions, GridReadyEvent, ICellRendererParams, Module, RowClickedEvent, RowGroupingDisplayType, RowHeightParams,
  ExcelCell, ExcelStyle,  ExcelExportParams,ExcelRow, ClientSideRowModelModule,
  RowSelectedEvent,
  ValidationModule
} from 'ag-grid-community';
import {
  MasterDetailModule,
  RowGroupingModule,
  ExcelExportModule,
  AllEnterpriseModule
} from 'ag-grid-enterprise';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject, Subscription, BehaviorSubject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { gridReady } from '../../../create-request/actions/positions-table-actions';
import { PositionsLotsTableColumn } from '../../../shared/types/PositionsLotsTableColumn';
import { TableColumn, rowSelection } from '../../../shared/types/TableColumn';
import { TableComponentState } from '../../../shared/types/TableComponentState';
import { PositionLots } from '../../models/internal-transfer/PositionLots';
import { selectCostBasis, selectPositionLotDetails, selectPositionLotTableData, selectPositionsLotsTableState } from '../../reducers';
import { selectSubAccountId } from '../../../account-info-header/reducers';
import { InputEditorComponent } from '../../../shared/components/input-editor-renderer/input-cell-editor.component';
import { InputFieldPositionComponent } from '../../../shared/components/table-text-position-input-field/table-text-position-input-field.component';
import { TextFieldComponent } from '../../../shared/components/table-text-field/table-text-field.component';
import { InternalTransferActions, PositionsTableActions } from '../../actions';
import { AgGridAngular } from 'ag-grid-angular';
import { TextFloatingFilterComponent } from '../../../shared/components/text-floating-filter/text-floating-filter.component';
import { SetFloatingFilterComponent } from '../../../shared/components/set-floating-filter/set-floating-filter.component';
import { CustomErrorTransactionTableComponent } from '../../../shared/components/custom-error-transaction-table/custom-error-transaction-table.component';
import { agFilterNames } from '../../../shared/types/AgFilterNames';
import { positionConstants } from '../../../shared/utilities/Constants';
import { LotDetails } from '../../models/internal-transfer/LotDetails';
import { DateTime } from 'luxon';
import { InputFieldLotComponent } from '../../../shared/components/table-text-lot-input-field/table-text-lot-input-field.component';

@Component({
  standalone: false,
  selector: 'positions-lots-table',
  templateUrl: './positions-lots-table.component.html',
  styleUrls: ['./positions-lots-table.component.scss'],
})

export class PositionsLotsTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() showFilterCount: boolean;
  @Input() showTableOptions: boolean;
  @Input() showFloatingFilter: boolean;
  @Input() isInitiateAndReleaseFlowFromTable: boolean =false;
  @Input() isOneTimeTotalDist: boolean = false;
  costBasisMethod: string | undefined;
  gridApi: GridApi | undefined | null;
  gridColumnApi: GridApi | undefined | null;
  colNames = {
    checkbox: 'checkbox',
    expandCollapse: 'expandCollapse',
    positionSymbol: 'Symbol',
    positionName: 'Name',
    availableShares: 'Available shares',
    currentPricePerShare: 'Current price/share',
    costBasis: 'Cost basis',
    sharesToMove: 'Shares to move',
    estimatedMarketValue: 'Estimated market value',
    acquiredDate: 'Acquired Date',
    holdingPeriod: 'Holding Period'
  }
  public modules: Module[] = [
    ClientSideRowModelModule,
    RowGroupingModule,
    MasterDetailModule,
    ExcelExportModule,
    ValidationModule,
    AllEnterpriseModule
  ];
  public groupDisplayType: RowGroupingDisplayType = 'singleColumn';
  autoGroupColumnDef: ColDef = {
    minWidth: 29
  };
  columnDefs: ColDef[] = [];
  defaultExportParams: ExcelExportParams;
  totalRow: ExcelRow[];
  excelStyles: ExcelStyle[] = [];
  excelBorderStyle: ExcelStyle;
  defColumnDefs: ColDef[] = [
    {
      field: this.colNames.checkbox,
      headerName: ' ',
      resizable: false,
      lockPosition: true,
      width: 29,
      checkboxSelection: this.showCheckBox.bind(this),
      sortable: false,
      headerCheckboxSelection: this.showCheckBox.bind(this),
      filter: false,
      cellClass: 'customCellPadding',
    },
    {
      field: this.colNames.positionSymbol,
      floatingFilterComponent: 'customTextFloatingFilter',
      minWidth: 175,
      maxWidth: 175,
      lockPosition: true,
      floatingFilterComponentParams: {
        suppressFilterButton: true
      },
      sort: "asc",
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        suppressDoubleClickExpand: true,

      }
    },
    {
      field: this.colNames.positionName,
      tooltipField: this.colNames.positionName,
      resizable: false,
      cellStyle: { 'text-overflow': 'ellipsis', 'white-space': 'nowrap', 'overflow': 'hidden' },
      cellClass: 'custom-filter',
      filterParams: { showTooltips: true },
      type: 'leftAligned',
      lockPosition: true,
      minWidth: 300,
      maxWidth: 300,
      floatingFilterComponent: 'customTextFloatingFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: true
      },
    },
    {
      field: this.colNames.availableShares,
      headerName: this.colNames.availableShares,
      width: 130,
      filter: false,
      lockPosition: true,
      comparator: (valueA: string, valueB: string) => {
        const a = valueA.replace(',', '');
        const b = valueB.replace(',', '');
        const sharesA = parseFloat(a.substring(0).replace(/,/g, ""));
        const sharesB = parseFloat(b.substring(0).replace(/,/g, ""));
        return sharesA - sharesB;
      }
    },
    {
      field: this.colNames.currentPricePerShare,
      headerName: this.colNames.currentPricePerShare,
      resizable: false,
      type: 'rightAligned',
      width: 120,
      lockPosition: true,
      comparator: this.currencyComparator,
      filter: false
    },
    {
      field: this.colNames.costBasis,
      headerName: this.colNames.costBasis,
      resizable: false,
      type: 'rightAligned',
      width: 110,
      lockPosition: true,
      comparator: this.currencyComparator,
      filter: false,
      cellClass: 'rightTextAndBorder'
    },
    {
      field: this.colNames.sharesToMove,
      headerName: this.colNames.sharesToMove,
      resizable: false,
      colSpan: params => this.isRowRestricted(params) && !this.reviewConfirmationPage ? 2 : 1,
      width: 85,
      minWidth: 150,
      lockPosition: true,
      cellClass: ['input-editor-class', 'restrictionTextCellPadding'],
      sortable: false,
      filter: false,
      editable: this.isRowEditable.bind(this),
      singleClickEdit: true,
      cellEditor: 'inputEditor',
      cellRendererSelector: (params) => {
        if (this.reviewConfirmationPage) {
          return {
            component: (params: ICellRendererParams) => "<span class='sharesToMoveClass restrictionTextCellPadding input-editor-class'>" + params.value + "</span>"
          }
        }
        else if (!this.isRowRestricted(params)) {
          return {
            component: 'inputEditor',
          };
        }
        else {
          return {
            component: 'textField',
          };
        }
      },
    },
    {
      field: this.colNames.estimatedMarketValue,
      headerName: this.colNames.estimatedMarketValue,
      resizable: false,
      width: 185,
      comparator: this.currencyComparator,
      sortable: false,
      type: 'rightAligned',
      filter: false,
      lockPosition: true,
      cellClass: 'customCellPadding',
    },
    {
      field: 'LotDetail',
      headerName: '',
      resizable: true,
      width: 0,
      sortable: false,
      filter: false,
      hide: true,

    },
    {
      field: 'detailRows',
      headerName: '',
      resizable: true,
      width: 0,
      sortable: false,
      filter: false,
      hide: true,

    },
    {
      field: 'nodeCostBasis',
      headerName: '',
      resizable: true,
      width: 0,
      sortable: false,
      filter: false,
      hide: true,

    },
  ];
  public detailCellRendererParams: any = {
    refreshStrategy: "nothing",
    detailGridOptions: {
      rowHeight: 29,
      headerHeight: 29,
      components: {
        customEditor: InputEditorComponent,
        inputEditor: InputFieldPositionComponent,
        lotInputEditor: InputFieldLotComponent
      },
      setColumnVisible(index: number) {
        this.columnDefs[index].hide = true;
      },
      sizeColumnsToMatchMasterTable(gridColumnApi: any) {
        this.columnDefs.forEach((lotColumn) => {
          lotColumn.width = gridColumnApi?.getColumn(lotColumn?.relatedMasterColumn)?.getActualWidth() ?? lotColumn.width;
        });
      },
      columnDefs: [
        {
          suppressHeaderMenuButton: true,
          suppressHeaderContextMenu: true,
          suppressHeaderFilterButton: true,
          field: '',
          headerName: '',
          relatedMasterColumn: this.colNames.checkbox,
          resizable: false,
          headerClass: 'detailSubHeadernoBorder',
          type: 'leftAligned',
          width: this.defColumnDefs.find(masterCol => masterCol.field === this.colNames.checkbox)?.width ?? 0,
          sort: 'asc,',
          cellStyle: {
            backgroundColor: '#F1F1F1',
          },
          hide: false
        },
        {
          field: '',
          headerName: '',
          relatedMasterColumn: this.colNames.positionSymbol,
          resizable: false,
          width: this.defColumnDefs.find(masterCol => masterCol.field === this.colNames.positionSymbol)?.width ?? 0,
          filter: false,
          headerClass: 'detailSubHeadernoBorder',
          sort: 'asc,',
          cellStyle: {
            backgroundColor: '#F1F1F1',

          },
          headerComponentParams: {
            template:
            `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
          }
        },
        {
          field: 'Acquired date',
          headerName: 'Acquired Date',
          relatedMasterColumn: this.colNames.positionName,
          resizable: false,
          type: 'leftAligned',
          headerClass: 'detailSubHeadernoBorder',
          width: this.defColumnDefs.find(masterCol => masterCol.field === this.colNames.positionName)?.width ?? 0,
          filter: false,
          sort: 'desc',
          sortable: true,
          sortingOrder: ['asc', 'desc'],
          comparator: (valueA: string, valueB: string) => (new Date(valueA) > new Date(valueB)) ? 1 : -1,
          cellClass: 'subGridCell',
          icons: {
            sortAscending: '<i class="sch-caret-up"/>',
            sortDescending: '<i class="sch-caret-down"/>',
          },
          headerComponentParams: {
            template:
              `<div data-ref="eLabel" class="ag-header-cell-label" style="position:absolute; padding-top: 6px;">
                <span data-ref="eText" class="subGridheader" role="presentation"></span>
                <span data-ref="eSortAsc"></span>
                <span data-ref="eSortDesc"></span>
              </div>`
          }
        },
        {
          field: 'Holding Period',
          headerName: '',
          relatedMasterColumn: this.colNames.availableShares,
          resizable: false,
          width: this.defColumnDefs.find(masterCol => masterCol.field === this.colNames.availableShares)?.width ?? 0,
          filter: false,
          headerClass: 'detailSubHeadernoBorder',
          sort: 'asc,',
          cellClass: 'subGridCell',
          headerComponentParams: {
            template:
            `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
          }
        },
        {
          field: 'Current price/share',
          headerName: '',
          relatedMasterColumn: this.colNames.currentPricePerShare,
          resizable: false,
          headerClass: 'detailSubHeadernoBorder',
          width: this.defColumnDefs.find(masterCol => masterCol.field === this.colNames.currentPricePerShare)?.width ?? 0,
          filter: false,
          sort: 'asc',
          type: 'rightAligned',
          cellClass: 'subGridCellV2',
          headerComponentParams: {
            template:
            `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
          }
        },
        {
          field: 'Cost Basis',
          headerName: '',
          relatedMasterColumn: this.colNames.costBasis,
          headerClass: 'detailSubHeader',
          resizable: false,
          type: 'rightAligned',
          width: this.defColumnDefs.find(masterCol => masterCol.field === this.colNames.costBasis)?.width ?? 0,
          filter: false,
          sort: 'asc',
          cellClass: ['subGridCellV2', 'rightTextAndBorder'],
          headerComponentParams: {
            template:
            `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
          }
        },
        {
          field: 'Lots to move',
          headerName: '',
          relatedMasterColumn: this.colNames.sharesToMove,
          headerClass: 'detailSubHeadernoBorder',
          resizable: false,
          type: 'rightAligned',
          width: this.defColumnDefs.find(masterCol => masterCol.field === this.colNames.sharesToMove)?.width ?? 0,
          filter: false,
          suppressHeaderMenuButton: true,
          suppressHeaderContextMenu: true,
          suppressHeaderFilterButton: true,
          cellClass: ['input-editor-class', 'restrictionTextCellPadding', 'subGridCell'],
          sortable: false,
          editable: this.isLotRowEditable.bind(this),
          singleClickEdit: true,
          cellEditor: 'lotInputEditor',
          cellRendererSelector: (params: any) => {
            return { component: 'lotInputEditor' };
          }
        },
        {
          field: 'Estimated market value',
          headerName: '',
          relatedMasterColumn: this.colNames.estimatedMarketValue,
          headerClass: 'detailSubHeadernoBorder',
          resizable: false,
          type: 'rightAligned',
          width: this.defColumnDefs.find(masterCol => masterCol.field === this.colNames.estimatedMarketValue)?.width ?? 0,
          filter: false,
          sort: 'asc',
          cellClass: ['subGridCellV2', 'emvPaddingClass'],
          headerComponentParams: {
            template:
            `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
          }
        },
        {
          field: 'nodeCostBasis',
          headerName: '',
          resizable: true,
          width: 0,
          sortable: false,
          filter: false,
          hide: true,

        },
      ]
    },
    getDetailRowData: (params: any) => {
      const lotsResponse: any[] = Array.of(params.data.lotDetail);
      let i = 0
      let fullLotDetails: Array<any> = [];
      let lotDetail: Array<any> = [];
      while (lotsResponse[0].length > i) {
        lotDetail = lotsResponse.map(position => {
          let existingLotsToMoveAndEmv = this.costBasisMethod == 'None' ? this.returnLotStoreData(position[i]['lotId'], params): ['','']
          return {
            'Acquired date': position[i].acquiredDate,
            'Holding Period': this.decimalPipe.transform(position[i].lotQuantity, '1.0-6') + ' (' + position[i].holdingPeriod.toLowerCase() + '-term' + ')',
            'Symbol': params.data['Symbol'],
            'Current price/share': params.data['Current price/share'],
            'Cost Basis': this.currencyPipe.transform(position[i].costBasis),
            'Estimated market value': existingLotsToMoveAndEmv[1] !== '' ? existingLotsToMoveAndEmv[1] : this.emvLogic(position[i], params),
            'nodeCostBasis': params.data.nodeCostBasis,
            'setToAverage': position.setToAverage,
            'Lots to move': existingLotsToMoveAndEmv[0] !== '' ? existingLotsToMoveAndEmv[0] : ((position[i]['lotsToMove'] === undefined || this.costBasisMethod !== 'None' && this.costBasisMethod !== undefined) ? '' : this.returnFormattedSharesValue(position[i]['lotsToMove'])),
            'restrictions': params.data.restrictions,
            'masterNode': params,
            'lotId': position[i]['lotId'],
            'valMultiplier': position[i]['valMultiplier']
          }
        })
        i++;
        fullLotDetails = fullLotDetails.concat(lotDetail);
      }
      params.successCallback(fullLotDetails);
      //this.updateDetailRows();
    }
  };
  @Input() reviewConfirmationPage: boolean;
  @Input() showSelectPositionError: boolean;
  @Input() maxLotsWarningMessage: string[];
  @Input() maxLotsWarning: {displayWarning: boolean} = {displayWarning:false}
  reviewRowData$!: Observable<any[]>;
  public domLayout: 'autoHeight';
  destroy$: Subject<boolean> = new Subject<boolean>();
  rowData$!: Observable<PositionsLotsTableColumn[]>;
  positionTableState$: Observable<TableComponentState>;
  subAccountId: string;
  rowSelection: rowSelection = 'multiple';
  positions: number;
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true
  };
  quantityMismatch: string = positionConstants.positionMismatchRestriction
  displayTable$ = new BehaviorSubject(false);
  tableLoading$ = new BehaviorSubject(false);
  tableMessage: string;
  shares: string;
  emvFormatted: string | null;
  lotDetail: PositionsLotsTableColumn[];
  detailRowAutoHeight: true;
  showExpandCollapse = true;
  displayedRows: number = 0;
  numberOfFilters: number = 0;
  hasAnyQuantityMismatchPositions: boolean = false;
  totalSharesSelected: number = 0;
  displaytotalShared: string | null = '';
  selectedValue: number = 0;
  displaySelectedValue: string | null = '';
  lastCostBasis: any = '';
  toIndex: number;
  expanded: boolean = false;
  sortingOrder: [];
  frameworkComponents: any;
  customErrorComponent: string;
  customErrorComponentParams: { noRowsMessageFn: (item: string) => string } = { noRowsMessageFn: (item: string) => 'string'};
  loadingOverlayComponent: string;
  loadingOverlayComponentParams: { loadingFn: (item: boolean) => boolean, lockModalVersion: boolean,};
  columnStateBeforePrint: ColumnState[] | undefined;
  gridHeight: string = '500px';
  firstLoadtable = true;
  gridOptions: GridOptions;
  componentStateSub: Subscription;
  isEdit: boolean;
  lastPage: number | undefined = -1;
  lastPageSize: number | undefined = -1
  titleText: string = positionConstants.maxLotsWarning;
  defaultColumnDefs: ColDef = {
    filter: agFilterNames.text,
    sortingOrder: ['asc', 'desc'],
    suppressHeaderMenuButton: true,
    suppressHeaderContextMenu: true,
    suppressHeaderFilterButton: true,
    sortable: true,
    resizable: false,
    unSortIcon: true,
    flex: 1,
    minWidth: 29,
    floatingFilter: true
  };
  icons = {
    sortAscending: '<i class="sch-caret-up "/>',
    sortDescending: '<i class="sch-caret-down"/>',
    filter: '<i class="sch-search" />',
    sortUnSort: '<i class="sch-caret-down"/>'
  };
  showSetToAverageMessageCounter: number = 0;
  setToAverageInformationText: string = positionConstants.SetToAverageInformationMessage;
  selectPositionErrorText: string = positionConstants.SelectPositionErrormessage;
  positionMismatchDisclaimer: string = positionConstants.positionMismatchDisclaimer;
  @ViewChild('myGrid') grid!: AgGridAngular;
  ngOnInit(): void {
    this.frameworkComponents = {
      customTextFloatingFilter: TextFloatingFilterComponent,
      customSetFloatingFilter: SetFloatingFilterComponent,
      customErrorComponent: CustomErrorTransactionTableComponent,
      customEditor: InputEditorComponent,
      inputEditor: InputFieldPositionComponent,
      lotInputEditor: InputFieldLotComponent,
      textField: TextFieldComponent
    };
    this.customErrorComponent = 'customErrorComponent'
    this.displayedRows = this.setDisplayedRows();
    this.numberOfFilters = this.setNumberOfFilters();
    this.columnDefs = this.defColumnDefs;
    this.loadingOverlayComponentParams = {
      loadingFn: () => { return false },
      lockModalVersion: false
    };
    this.positionTableState$ = this.store.select(selectPositionsLotsTableState);
    this.store.select(selectPositionsLotsTableState).pipe(takeUntil(this.destroy$)).subscribe(state => this.isEdit = state.isEdit);
    this.store.select(selectCostBasis).pipe(takeUntil(this.destroy$)).subscribe(info => this.costBasisMethod = info);
    this.store.select(selectPositionLotDetails).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.positions = info.totals.totalNoOfPositions;
      this.shares = info.totals.totalQuantity.toLocaleString("en-US", { style: 'decimal', maximumFractionDigits: 20});
      this.emvFormatted = this.currencyPipe.transform(info.totals.totalEstimatedMarketValue);
    });
    if (this.reviewConfirmationPage) {
      this.rowData$ = this.store.pipe(
        select(selectPositionLotTableData),
        take(1),
        map(positionsLotDetails => this.mapPositionLotDetailsReview(positionsLotDetails))
      );
    }
    else if (this.isEdit) {
      this.rowData$ = this.store.select(selectPositionLotTableData).pipe(
        take(1),
        map(positionsLotDetails => this.mapToInputPositionTableFromEdit(positionsLotDetails)),
      );
      this.rowData$.subscribe(positions => {
        this.store.dispatch(InternalTransferActions.updateRowData({ response: this.mapToInputPositionTableFromEdit(positions) }));
      });
    }
    else {
      this.rowData$ = this.store.select(selectPositionLotDetails).pipe(
        takeUntil(this.destroy$),
        map(positionsLotDetails => this.mapPositionLotDetails(positionsLotDetails.positions))
      );
      this.store.select(selectPositionLotDetails).pipe(takeUntil(this.destroy$)).subscribe(info => {
        this.store.dispatch(InternalTransferActions.updateRowData({ response: this.updatePositionsTableStore(info.positions) }));
      });
    }

    this.managePositionLotTableState();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColumnDefs,
      autoGroupColumnDef: this.autoGroupColumnDef,
      embedFullWidthRows: true,
      defaultExcelExportParams: this.defaultExportParams,
      theme: 'legacy'
    }
  }

  isRowRestricted(params: any) {
    if(params.data.restrictions.isRestricted) {
      if (params.data.restrictions.restrictionText === this.quantityMismatch && params.data.nodeCostBasis !== "None") {
        return false;
      }
      else {
        return true;
      }
    }
    return false;
  }

  showCheckBox(params:any){
    if(this.reviewConfirmationPage){
      return false
    }
    return true;
  }

  returnFormattedSharesValue(shares: string | number) {
    if (this.reviewConfirmationPage) {
      if (shares == '') {
        return shares
      }
      return Number(shares).toLocaleString("en-US", { style: 'decimal', maximumFractionDigits: 20});
    }
    else {
      return shares.toString().replaceAll(',', '')
    }
  }

  public mapPositionLotDetails(positionsLotDetails: PositionLots[]): PositionsLotsTableColumn[] {
    return positionsLotDetails.map(position => {
      return {
        Symbol: position.symbol,
        Name: position.setToAverage && this.doesNotIncludeSetToAverage(position.symbolName) ? `${this.convertNameToCamelCase(position.symbolName)} (Set to Average)` : this.convertNameToCamelCase(position.symbolName),
        RowHeight: this.calculateRowHeightByRestrictionText(position.restriction.restrictionText),
        'Available shares': `${this.decimalPipe.transform(position.totalQuantity, '1.0-5')} (${position.numberOfLots} ${position.numberOfLots === 1 ? 'lot' : 'lots'})`,
        'Current price/share': position.currentPricePerShare,
        'Cost basis': position.costBasis,
        'Shares to move': '',
        'Estimated market value': '',
        "lotDetail": position.lots,
        'restrictions': position.restriction,
        'setToAverage': position.setToAverage,
        'Quantity': position.quantity,
        'cmtSequenceId': position.cmtSequenceId,
        'schwabSecurityId': position.schwabSecurityId,
        'valMultiplier': position.valMultiplier,
        'nodeCostBasis': '',
        'detailRows': []
      }
    });
  };

  public onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.api;
    this.displaytotalShared = '';
    this.displaySelectedValue = '';
    this.manageCostBasisComponents();
    this.updateValues();
    setTimeout(() => {
      this.expandOrCollapse();
    }, 5);
    this.expandOrCollapse();
    if (this.reviewConfirmationPage === true) {
      this.gridApi.setColumnsVisible(['checkbox'], false);
      this.detailCellRendererParams.detailGridOptions?.setColumnVisible(0);
      this.updateTotalFooterReview();
      this.store.pipe(select(selectPositionLotTableData), take(1)).subscribe((rowData) => {
        if (rowData[0]['nodeCostBasis'] === 'None') {
          this.expandOrCollapse();
          const checkbox = document.getElementById(
            'expandAllId',
          ) as HTMLInputElement | null;
          checkbox!.checked = true;
        }
      });
    }
    else if (this.isEdit) {
      this.store.dispatch(PositionsTableActions.loadEditComplete());
      this.updateTotalFooterReview();
    }
    this.gridApi?.sizeColumnsToFit();
    this.detailCellRendererParams.detailGridOptions?.sizeColumnsToMatchMasterTable(this.gridColumnApi);
    this.setHasAnyQuantityMismatchPositions();
    if(this.costBasisMethod == 'None' && !this.reviewConfirmationPage){
      const checkbox = document.getElementById(
        'expandAllId',
      ) as HTMLInputElement | null;
      checkbox!.checked = true;
      this.expandOrCollapse()
    }
  }

  scrollToHtmlId(id: string) {
    const htmlElementId = document.getElementById(
      id,
    ) as HTMLInputElement | null;

    setTimeout(function () {
      htmlElementId?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
    }, 0);
  }

  isRowEditable (params: any) {
    return !(this.reviewConfirmationPage || this.isRowRestricted(params) || this.costBasisMethod == 'None');
  }

  isLotRowEditable (params: any) {
    return !(this.reviewConfirmationPage || this.isRowRestricted(params) || this.costBasisMethod != 'None');
  }


  updateTotalFooterReview() {
    let totalShares = 0;
    let totalemv = 0;
    this.gridApi?.forEachNode((rowNode, index) => {
      totalShares = totalShares + Number(rowNode.data['Shares to move'].toString()?.replaceAll(',', ''));
      totalemv = Number(totalemv + Number(rowNode.data['Estimated market value'].toString()?.replaceAll(new RegExp(/\,|\$/g), '') ?? 0));
    });
    this.totalSharesSelected = totalShares;
    this.selectedValue = totalemv;
    this.displaytotalShared = (totalShares !== 0) ? this.decimalPipe.transform(totalShares, '1.0-5'):'';
    this.displaySelectedValue = this.totalSharesSelected === 0 ? '' : this.currencyPipe.transform(totalemv);
  }

  updateValues() {
    if (this.gridApi) {
      this.displayedRows = this.setDisplayedRows();
      this.numberOfFilters = this.setNumberOfFilters();
    }
  }

  disbaleRestrictedCheckboxes() {
    if (this.gridApi?.getColumnDef('Symbol') !== null) {
      this.gridApi?.forEachNode((rowNode, index) => {
        let restricted: boolean = false;
        if(rowNode.master === true) {
          if (this.costBasisMethod !== 'None') {
            restricted = rowNode.data.restrictions.isRestricted && rowNode.data.restrictions.restrictionText !== this.quantityMismatch;
          }
          else {
            restricted = rowNode.data.restrictions.isRestricted;
          }
        }
        if (restricted || this.reviewConfirmationPage) {
          rowNode.selectable = false;
        }
        else {
          rowNode.selectable = true;
        }
      });
    }
  }

  clearFilters(event: any) {
    if (event.pointerType === "mouse") {
      event.preventDefault();
      this.gridApi?.setFilterModel(null);
    }
  }

  ngOnChanges(): void {
    if (this.gridApi) {
      setTimeout(() => {
        this.updateValues();
      });
    }

    if(this.maxLotsWarning.displayWarning || this.showSelectPositionError){
      this.scrollToHtmlId('errorBanners');
    }
  }

  expandOrCollapse() {
    this.expanded = !this.expanded;
    this.gridApi?.forEachNode((rowNode, index) => {
      if (this.expanded) {
          rowNode.setExpanded(true);
      }
      else {
          rowNode.setExpanded(false);
      }
    });
  }

  emvLogic(position: any, params: any) {
    return ((position['lotsToMove'] !== '') && (position['lotsToMove'] !== undefined)) ? this.currencyPipe.transform(((Number(params.data['Current price/share'].split('$')[1])) * Number(position['lotsToMove']) * Number(params.data['valMultiplier']))) : ''
  }

  isNumberOrEmptyString(value: string | number): boolean {
    if (value == '') {
      return true
    }
    if (this.isNumber(value)) {
      return true
    }
    return false
  }

  onPositionsCellValueChanged(params: CellValueChangedEvent) {
    if (params.newValue.toString() === params.data['Shares to move'].toString()) {
      if (this.isNumberOrEmptyString(params.newValue) && this.isNumberOrEmptyString(params.oldValue) && params.newValue.constructor !== Array) {
        this.updateStorePosition(params.data['Symbol'], params.newValue);
        this.costBasisMethod = params.data.nodeCostBasis;
        let restriction: boolean = this.isRowRestricted(params);
        this.showSetToAverageMessageCounter = this.showSetToAverageMessageCounter < 0 ? 0 : this.showSetToAverageMessageCounter;
        if (params?.colDef?.field == 'Shares to move') {
          const sharesToMove = this.isNumber(params.data['Shares to move']) ? + params.data['Shares to move'] : 0;
          const availableShares = +params.data["Available shares"].split(' ')[0].replaceAll(',', '').replace('-', '');
          const pricePerShare = params.data["Current price/share"].replace(',', '').replace('$', '');
          const valMultiplier = params.data["valMultiplier"];
          const oldValue = this.isInvalidInput(params.oldValue, availableShares, params?.data?.Quantity?.selectedQuantityMinimum, params?.data?.Quantity?.selectedQuantityMinimumDenomination) ? '' : params.oldValue;
          if (sharesToMove != null && sharesToMove > 0 && !restriction) {
            if (availableShares >= sharesToMove) {
              if (this.isInvalidInput(sharesToMove, availableShares, params?.data?.Quantity?.selectedQuantityMinimum, params?.data?.Quantity?.selectedQuantityMinimumDenomination)) {
                params.data["Estimated market value"] = '';
                this.totalSharesSelected = this.totalSharesSelected - oldValue;
                this.selectedValue = this.selectedValue - (oldValue * pricePerShare * valMultiplier);
              } else {
                params.data["Estimated market value"] = this.currencyPipe.transform(sharesToMove * pricePerShare * valMultiplier);
                if (oldValue !== params.newValue) {
                  this.totalSharesSelected = this.totalSharesSelected - oldValue + sharesToMove;
                  this.selectedValue = this.selectedValue - (oldValue * pricePerShare * valMultiplier) + (sharesToMove * pricePerShare * valMultiplier);
                  this.showSetToAverageMessageCounter = params.data.setToAverage && oldValue === '' ? this.showSetToAverageMessageCounter + 1 : this.showSetToAverageMessageCounter;
                }
              }
            } else if (this.isInvalidInput(sharesToMove, availableShares, params?.data?.Quantity?.selectedQuantityMinimum, params?.data?.Quantity?.selectedQuantityMinimumDenomination)) {
              params.data["Estimated market value"] = '';
              this.totalSharesSelected = this.totalSharesSelected - oldValue;
              this.selectedValue = this.selectedValue - (oldValue * pricePerShare * valMultiplier);
            }
            if (restriction) {
              this.clearShareToMove(params);
            }
          } else {
            if (oldValue === '' || sharesToMove == 0) {
              this.totalSharesSelected = this.totalSharesSelected - oldValue;
              this.selectedValue = this.selectedValue - (oldValue * pricePerShare * valMultiplier);
            }
            this.clearShareToMove(params);
          }
          if (availableShares === sharesToMove) {
            this.gridApi?.forEachNode((node, index) => {
              if (node.data['Symbol'] === params.data['Symbol']) {
                node.setSelected(true)
              }
            });
          }
          else if (params.node.isSelected()) {
            params.node.setSelected(false);
          }
          else {
            this.gridApi?.forEachNode((node, index) => {
              if (node.data['Symbol'] === params.data['Symbol']) {
                node.setSelected(false)
              }
            });
          }
          this.updateTotalFooterReview();
          params.api.refreshCells();
        }
      }
    }
  }


  isInvalidInput(sharesToMove: number, availableShares: number, selectedQuantityMinimum: number, selectedQuantityMinimumDenomination: string) {
    const isDecimal = (sharesToMove - Math.floor(sharesToMove)) !== 0;
    const isDecimalAvailble = (availableShares) - Math.floor(availableShares) !== 0;
    const value = Number(sharesToMove?.toString()?.replace(',', '')) ?? 0;
    if (value > availableShares
      || (!isDecimalAvailble && isDecimal)
      || (isDecimalAvailble && isDecimal && availableShares.toString().split('.')[1]?.length < value?.toString().split('.')[1]?.length)
      || ((value < selectedQuantityMinimum || (((value) % (parseFloat(selectedQuantityMinimumDenomination))) > .001)) && (value !== 0 && value !== availableShares))) {
      return true;
    }
    return false;
  }

  public mapPositionLotDetailsReview(position: any[]): any[] {
    let data = position.map(position => {
      if (position['Shares to move'] !== '') {
        if (this.isEdit && !this.isOneTimeTotalDist && position.setToAverage) {
            this.showSetToAverageMessageCounter++;
        }
        return {
          'Symbol': position['Symbol'],
          Name: position.setToAverage && this.doesNotIncludeSetToAverage(position['Name']) ? `${this.convertNameToCamelCase(position['Name'])} (Set to Average)` : this.convertNameToCamelCase(position['Name']),
          RowHeight: positionConstants.tableRowHeight,
          'Available shares': position['Available shares'],
          'Current price/share': position['Current price/share'],
          'Cost basis': position['Cost basis'],
          'Shares to move': this.decimalPipe.transform(position['Shares to move'], '1.0-5'),
          'Estimated market value': this.currencyPipe.transform((Number(position['Shares to move']) * Number(position['Current price/share'].split('$')[1])) * Number(position['valMultiplier'])),
          "lotDetail": this.filterOutEmptyLotsToMove(position['lotDetail'], position['nodeCostBasis']),
          'restrictions': position['restrictions'],
          'Quantity': position['Quantity'],
          'cmtSequenceId': position['cmtSequenceId'],
          'schwabSecurityId': position['schwabSecurityId'],
          'valMultiplier': position['valMultiplier'],
          'nodeCostBasis': position['nodeCostBasis'],
          'setToAverage': position.setToAverage,
        }
      }
    })
    data = data.filter(Boolean);
    return data;
  };

  filterOutEmptyLotsToMove(pos: any[], costBasis: string) {
    let lotData = pos.map((lot: any) => {
      if ((lot['lotsToMove'] !== '') && (lot['lotsToMove'] !== undefined)) {
        return {
          'acquiredDate': lot['acquiredDate'],
          'costBasis': lot['costBasis'],
          'holdingPeriod': lot['holdingPeriod'],
          'purchasePrice': lot['purchasePrice'],
          'purchaseDate': lot['purchaseDate'],
          'lotQuantity': lot['lotQuantity'],
          'lotId': lot['lotId'],
          'lotsToMove': lot['lotsToMove']
        };
      }
      else if (costBasis !== 'None') {
        return lot;
      }
    });
    lotData = lotData.filter(Boolean);
    return lotData;
  }

  manageCostBasisComponents() {
    this.store.select(selectCostBasis).pipe(takeUntil(this.destroy$)).subscribe(info => {
      if (!this.reviewConfirmationPage && !this.isEdit) {
        //this.gridApi?.setGridOption("loading", true);
        setTimeout(() => {
          this.costBasisMethod = info;
          this.disbaleRestrictedCheckboxes();
          if (this.reviewConfirmationPage) {
            info = undefined;
          }
          const checkbox = document.getElementById(
            'expandAllId',
          ) as HTMLInputElement | null;
          if (checkbox) {
            if (this.gridApi?.getColumnDef('Symbol') !== null) {
              this.gridApi?.forEachNode((rowNode, index) => {
                rowNode.data.nodeCostBasis = info;
              });
              if (info !== 'None') {
                this.gridApi?.forEachNode((rowNode, index) => {
                  const lotDetail: [] = rowNode.data['lotDetail'];
                  const lots = this.clearLotsToMove(lotDetail);
                  rowNode.data['lotDetail'] = lots;
                });
              }
              if (info == "None" && checkbox?.checked != true) {
                checkbox!.checked = true;
                if (!this.isEdit) {
                  this.gridApi?.forEachNode((rowNode, index) => {
                    rowNode.setDataValue('Shares to move', '');
                  });
                }
                this.expandOrCollapse();
              }
              else if (info == "None" && checkbox?.checked === true && !this.isEdit) {
                this.gridApi?.forEachNode((rowNode, index) => {
                  rowNode.setDataValue('Shares to move', '');
                });
              }
              else if (info != "None" && checkbox?.checked === true) {
                checkbox!.checked = false;
                this.gridApi?.forEachNode((rowNode, index) => {
                  rowNode.setExpanded(true);
                });
                setTimeout(() => {
                  this.expandOrCollapse();
                }, 1);
              }
              else if (info != "None" && checkbox && checkbox?.checked !== true && !this.firstLoadtable) {
                checkbox!.checked = false;
                this.gridApi?.forEachNode((rowNode, index) => {
                  rowNode.setExpanded(true);
                });
                this.expanded = !this.expanded;
                setTimeout(() => {
                  this.expandOrCollapse();
                }, 1);
              }
              if ((info !== 'None') && (this.lastCostBasis == 'None' || this.lastCostBasis == '')) {
                this.gridApi?.forEachDetailGridInfo(grid => {
                  grid?.api?.clearFocusedCell()
                  grid.api?.forEachNode(node => {
                    node.setDataValue('Lots to move', '');
                    node.setDataValue('Estimated market value', '');
                  })
                });
              }
              this.firstLoadtable = false;
              this.gridApi?.refreshCells();
              this.gridApi?.redrawRows();
            }
          }
          this.lastCostBasis = info;
          setTimeout(() => {
            this.gridApi?.hideOverlay()
          }, 1);
        }, 1);
      }
    });
  }

  updateDetailRows() {
    this.gridApi?.forEachNode(node => {
      node.setDataValue('detailRows', [])
    })
  }

  private setDisplayedRows(): number {
    var displayedRows = 0;
    this.gridApi?.forEachNodeAfterFilter(() => displayedRows++);
    return displayedRows;
  }

  private setHasAnyQuantityMismatchPositions(): void {
    this.gridApi?.forEachNode((row) => {
      if (row.data.restrictions.restrictionText === positionConstants.positionMismatchRestriction) {
        this.hasAnyQuantityMismatchPositions = true;
      }
    })
  }

  clearShareToMove(params: CellValueChangedEvent) {
    this.showSetToAverageMessageCounter = params.data.setToAverage ? this.showSetToAverageMessageCounter - 1 : this.showSetToAverageMessageCounter;
    params.data["Shares to move"] = '';
    params.data["Estimated market value"] = '';
  }

  isNumber(value: string | number): boolean {
    return ((value != null) &&
      (value !== '') &&
      !isNaN(Number(value.toString())));
  }

  onFilterChanged(params: FilterChangedEvent) {
    this.updateValues();
  }

  onColumnMoved(params: ColumnMovedEvent) {
    this.toIndex = params?.toIndex ?? 0;
  }

  onDragStopped(params: DragStoppedEvent) {
    const lastIndex = (params.api.getColumns()?.length ?? 0) - 1;

    if (lastIndex && this.toIndex >= lastIndex) {
      params.api.moveColumnByIndex(this.toIndex, (lastIndex - 1));
    }
  }

  calculateEmv(lotsToMove: string, currentPrice: string, valMultiplier: string) {
    return this.currencyPipe.transform(Number(lotsToMove) * Number(currentPrice) * Number(valMultiplier));
  }

  updateNodeCostBasis(params:any){
    params.node?.setDataValue('nodeCostBasis', this.costBasisMethod);
  }

  onPageChanged() {
    let currentPageSize = this.gridApi?.paginationGetPageSize();
    let currentPage = this.gridApi?.paginationGetCurrentPage();
    if (this.lastPage !== currentPage || this.lastPageSize !== currentPageSize) {
      this.scrollToHtmlId('positionHeader');
    }
    this.lastPage = currentPage;
    this.lastPageSize = currentPageSize;

    if (this.costBasisMethod === 'None') {
      if (this.gridApi?.getSelectedRows().length === this.positions) {
        //this.gridApi?.setGridOption("loading", true);
        setTimeout(() => {
          this.gridApi?.forEachDetailGridInfo(grid => {
            grid?.api?.clearFocusedCell()
            grid.api?.forEachNode(node => {
              if (!node.data['restrictions']['isRestricted']) {
                node.setDataValue('Lots to move', node.data['Holding Period'].split(' ')[0]?.replaceAll(',', ''));
                node.setDataValue('Estimated market value', this.calculateEmv(node.data['Holding Period'].split(' ')[0]?.replaceAll(',', ''), node.data['Current price/share'].split('$')[1], node.data.masterNode.data.valMultiplier));
                node.setDataValue('nodeCostBasis', this.costBasisMethod)
              }
            })
          });
          this.gridApi?.refreshCells();
          setTimeout(() => {
            this.gridApi?.hideOverlay()
          }, 1);
        }, 1);
      } else {
        let rowData: TableColumn[] = [];
        this.store.select(selectPositionLotTableData).pipe(take(1)).subscribe((data) => {
          rowData = data;
        });
        this.gridApi?.forEachDetailGridInfo((grid) => {
          grid?.api?.clearFocusedCell();
          grid?.api?.forEachNode((node) => {
            if(!node.data['restrictions']['isRestricted']) {
              const pos = rowData.find((position: TableColumn) => position['Symbol'] === node.data['Symbol']);
              if (pos !== undefined) {
                const lot = pos['lotDetail'].find((lotData: TableColumn) => lotData['lotId'] === node.data['lotId']);
                if (lot !== undefined) {
                  const emv = this.calculateEmv(lot['lotsToMove'], node.data['Current price/share'].split('$')[1], node.data.masterNode.data.valMultiplier);
                  node.setDataValue('Lots to move', lot['lotsToMove']);
                  node.setDataValue('Estimated market value', emv === '$0.00' ? '' : emv);
                  node.setDataValue('nodeCostBasis', this.costBasisMethod);
                }
              }
            }
          })
        })
      }
    }
  }

  returnLotStoreData(lotId: string, params: any) {
    let rowData: TableColumn[] = [];
    this.store.select(selectPositionLotTableData).pipe(take(1)).subscribe((data) => {
      rowData = data;
    });
    const pos = rowData.find((position: TableColumn) => position['Symbol'] === params.data['Symbol']);
    if (pos !== undefined) {
      const lot = pos['lotDetail'].find((lotData: TableColumn) => lotData['lotId'] === lotId);
      if (lot !== undefined) {
        if (lot['lotsToMove'] === '' || lot['lotsToMove'] === undefined) {
          return ['', ''];
        }
        let lotsToMove = (lot['lotsToMove'].replaceAll(',', ''));
        let emv = ((lotsToMove !== '') && (lotsToMove !== undefined)) ? this.currencyPipe.transform(((Number(params.data['Current price/share'].split('$')[1])) * Number(lotsToMove) * Number(params.data['valMultiplier']))) : ''
        return [this.returnFormattedSharesValue(lotsToMove), emv]
      }
    }
    return ['', ''];
  }

  onRowSelect(event: RowSelectedEvent) {
    //this.gridApi?.setGridOption("loading", true);
    setTimeout(() => {
      this.gridApi?.clearFocusedCell();
      this.updateNodeCostBasis(event)
      if (event.node.isSelected()) {
        event.node.setDataValue('Shares to move', event.data["Available shares"].split(' ')[0].replaceAll(',', '').replace('-', ''));
        if (this.costBasisMethod === 'None') {
          if (!event.data['restrictions']['isRestricted']) {
            event.api?.getDetailGridInfo('detail_' + event.node.id)?.api?.clearFocusedCell()
            event.api?.getDetailGridInfo('detail_' + event.node.id)?.api?.forEachNode(node => {
              node.setDataValue('nodeCostBasis', this.costBasisMethod);
              node.setDataValue('Lots to move', node.data['Holding Period'].split(' ')[0]?.replaceAll(',', ''));
              node.setDataValue('Estimated market value', this.calculateEmv(node.data['Holding Period'].split(' ')[0]?.replaceAll(',', ''), node.data['Current price/share'].split('$')[1], event.node.data.valMultiplier));
            });
            this.updateStoreSharesToMove(event.data, true, false);
          }
        }
      }
      else if (event.data["Available shares"].split(' ')[0]?.replaceAll(',', '').replace('-', '') === event.data["Shares to move"]) {
        event.node.setDataValue('Shares to move', '');
        if (this.costBasisMethod === 'None') {
          if (!event.data['restrictions']['isRestricted']) {
            event.api?.getDetailGridInfo('detail_' + event.node.id)?.api?.clearFocusedCell()
            event.api?.getDetailGridInfo('detail_' + event.node.id)?.api?.forEachNode(node => {
              node.setDataValue('Lots to move', "");
              node.setDataValue('Estimated market value', '')
            });
            this.updateStoreSharesToMove(event.data, false, true);
          }
        }
      }
      this.gridApi?.refreshCells();
      setTimeout(() => {
        this.gridApi?.hideOverlay()
      }, 1);
    }, 1);
  }

  updateStoreSharesToMove(selectedPosition: any, selecting: boolean, clearShares: boolean) {
    this.store.pipe(select(selectPositionLotTableData), take(1)).subscribe((rowData) => {
      let positionData = rowData.map(position => {
        if (position['Symbol'] === selectedPosition['Symbol']) {
          return {
            ...position,
            'Shares to move': clearShares ? '' : position['Shares to move'],
            'lotDetail': this.updateLotsToMove(position['lotDetail'], selecting),
            'nodeCostBasis': (selectedPosition['nodeCostBasis'] === undefined) ? position['nodeCostbasis'] : selectedPosition['nodeCostBasis']
          };
        }
        else {
          return {
            ...position,
            'nodeCostBasis': (selectedPosition['nodeCostBasis'] === undefined) ? position['nodeCostbasis'] : selectedPosition['nodeCostBasis']
          };
        }

      });
      this.store.dispatch(InternalTransferActions.updateRowData({ response: positionData }));
    });
  }

  updateStorePosition(symbolName: string, sharesToMove: string) {
    this.store.pipe(select(selectPositionLotTableData), take(1)).subscribe((rowData) => {
      let positionData = rowData.map(position => {
        if (position['Symbol'] === symbolName) {
          return {
            ...position,
            'Shares to move': sharesToMove
          };
        }
        else {
          return position;
        }
      });
      this.store.dispatch(InternalTransferActions.updateRowData({ response: positionData }));
    });
  }

  updateLotsToMove(lots: LotDetails[], selecting: boolean) {
    let lotData = lots.map((lot: any) => {
      return {
        'acquiredDate': lot['acquiredDate'],
        'costBasis': lot['costBasis'],
        'holdingPeriod': lot['holdingPeriod'],
        'lotQuantity': lot['lotQuantity'],
        'lotId': lot['lotId'],
        'purchasePrice': lot['purchasePrice'],
        'purchaseDate': lot['purchaseDate'],
        'lotsToMove': selecting ? lot['lotQuantity'].toString().split(' ')[0] : '',
      };
    });
    return lotData;
  }

  clearLotsToMove(lots: LotDetails[]) {
    let lotData = lots.map(lot => {
        return {
            ...lot,
            'lotsToMove': ''
        }
    });
    return lotData;
  }

  getRowHeight = (
    params: RowHeightParams
  ) => params.data.RowHeight;

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  calculateRowHeightByRestrictionText(restriction: string) {
    if (restriction.length <= 60) {
      return positionConstants.tableRowHeight;
    }
    else {
      return positionConstants.tableRestrictedMessageRowHeight;
    }
  }

  public updatePositionsTableStore(positionsLotDetails: PositionLots[]): PositionsLotsTableColumn[] {
    const data: PositionsLotsTableColumn[] = positionsLotDetails.map(position => {
      return {
        Symbol: position.symbol,
        Name: this.convertToCamelCase(position.symbolName),
        RowHeight: this.calculateRowHeightByRestrictionText(position.restriction.restrictionText),
        'Available shares': `${this.decimalPipe.transform(position.totalQuantity, '1.0-5')} (${position.numberOfLots} ${position.numberOfLots === 1 ? 'lot' : 'lots'})`,
        'Current price/share': position.currentPricePerShare,
        'Cost basis': position.costBasis,
        'Shares to move': '',
        'Estimated market value': '',
        'lotDetail': position.lots,
        'setToAverage': position.setToAverage,
        'restrictions': position.restriction,
        'Quantity': position.quantity,
        'cmtSequenceId': position.cmtSequenceId,
        'valMultiplier': position.valMultiplier,
        'schwabSecurityId': position.schwabSecurityId,
        'nodeCostBasis': ''
      }
    })
    return data;
  };

  public mapToInputPositionTableFromEdit(positions: any[]) {
    let data = positions.map(position => {
      return {
        'Symbol': position['Symbol'],
        Name: position.setToAverage && this.doesNotIncludeSetToAverage(position['Name']) ? `${this.convertNameToCamelCase(position['Name'])} (Set to Average)` : this.convertNameToCamelCase(position['Name']),
        RowHeight: this.calculateRowHeightByRestrictionText(position['restrictions']['restrictionText']),
        'Available shares': position['Available shares'],
        'Current price/share': position['Current price/share'],
        'Cost basis': position['Cost basis'],
        'Shares to move': position['Shares to move'],
        'Estimated market value': Number(position['Shares to move']) !== 0 ? this.currencyPipe.transform((Number(position['Shares to move']) * Number(position['Current price/share'].split('$')[1]) * Number(position['valMultiplier']))) : '',
        'lotDetail': position['lotDetail'],
        'restrictions': position['restrictions'],
        'Quantity': position['Quantity'],
        'cmtSequenceId': position['cmtSequenceId'],
        'schwabSecurityId': position['schwabSecurityId'],
        'valMultiplier': position['valMultiplier'],
        'nodeCostBasis': position['nodeCostBasis'],
        'setToAverage': position.setToAverage,
        'detailRows': []
      }
    })
    return data;
  }

  private setNumberOfFilters(): number {
    if (this.gridApi) {
      const filterModel = this.gridApi.getFilterModel();
      return Object.keys(filterModel).length;
    }
    return 0;
  }

  updateGridReady(ready: boolean) {
    this.store.dispatch(gridReady({ gridReady: ready }));
  }

  convertToCamelCase(symbolName: string) {
    return symbolName.split(' ').map(function (word, index) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }

  currencyComparator(valueA: string | number, valueB: string | number) {
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      valueA = +valueA.replace(/[^\-\w\s^.]/gi, '');
      valueB = +(valueB.replace(/[^\-\w\s^.]/gi, ''));
    }
    return +valueA - +valueB;
  }

  doesNotIncludeSetToAverage(name:string){
    return name.search('Set to Average') == -1
  }

  convertNameToCamelCase(symbolName: string) {
    return symbolName.split(' ').map(function (word, index) {
      return  word.charAt(0) != '(' ?  word == 'to' ? word: word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(): word.charAt(0) + word.charAt(1).toUpperCase() + word.slice(2).toLowerCase() ;
    }).join(' ');
  }

  exportTable(): void {
    this.updateTotalFooterReview();
    this.store.select(selectSubAccountId).pipe(takeUntil(this.destroy$)).subscribe(subAccountId => { this.subAccountId = subAccountId })
    this.totalRow = [
      {
        cells:
          [
            {
            data: { value: 'Totals', type: 'String', },
            mergeAcross: 4,
            styleId: 'header',
          },
          {
            data: { value: this.displaytotalShared, type: 'String', },
            styleId: 'header',
          },
          {
            data: { value: this.displaySelectedValue, type: 'String', },
            styleId: 'header',
          }
        ]
      }
    ]
    this.gridApi?.exportDataAsExcel(this.getParams());
  }
  noExportCol: string = 'checkbox';

  getParams() {
    const exportDate = DateTime.now().toFormat('MMddyyyy') + '_' + DateTime.now().toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET);
    return {
      author: '',
      fileName: 'InternalTransferPositionDetails_' + this.subAccountId + '_' + exportDate,
      sheetName: 'Sheet1',
      columnKeys: this.gridColumnApi?.getAllDisplayedColumns().filter(column => column.getColId() !== this.noExportCol),
      appendContent: this.totalRow
    }
  }

  isMasterDetail(){
    if(this.costBasisMethod === 'None'){
      return true
    }
    return false
  }

  managePositionLotTableState() {
    this.store.select(selectPositionsLotsTableState).pipe(takeUntil(this.destroy$)).subscribe(state => {
      if (state.isInitialLoad && !this.isInitiateAndReleaseFlowFromTable) {
        this.displayTable$.next(false);
        this.tableLoading$.next(false);
        this.tableMessage = positionConstants.ToAccountNotEnteredMessage;
        this.showSetToAverageMessageCounter = 0;
        this.positions = 0;
        this.shares = '0';
        this.totalSharesSelected = 0;
        this.selectedValue = 0;
        this.displaySelectedValue = '';
        this.emvFormatted = this.currencyPipe.transform(0);
        this.lotDetail = [];
        this.hasAnyQuantityMismatchPositions = false;
        this.expanded = false;
        const checkbox = document.getElementById(
          'expandAllId',
        ) as HTMLInputElement | null;
        if (checkbox) checkbox.checked = false;
        this.rowData$ = this.store.select(selectPositionLotDetails).pipe(
          takeUntil(this.destroy$),
          map(positionsLotDetails => this.mapPositionLotDetails(positionsLotDetails.positions))
        );
        this.store.select(selectPositionLotDetails).pipe(takeUntil(this.destroy$)).subscribe(info => {
          this.store.dispatch(InternalTransferActions.updateRowData({ response: this.updatePositionsTableStore(info.positions) }));
        });
      }
      else if (state.loading) {
        this.displayTable$.next(false);
        this.tableLoading$.next(true);
      }
      else if (state.hasError) {
        this.displayTable$.next(false);
        this.tableMessage = positionConstants.PositionLotErrorResponseMessage;
      }
      else if (this.positions === 0) {
        this.displayTable$.next(false);
        this.tableLoading$.next(false);
        this.tableMessage = positionConstants.AccountHasNoPositionsMessage;
      }
      else {
        this.displayTable$.next(true);
      }
    });
  }

  constructor(private store: Store, private currencyPipe: CurrencyPipe, private decimalPipe: DecimalPipe) {
    function cell(text: string, styleId?: string): ExcelCell {
      return {
        styleId: styleId,
        data: {
          type: /^\d+$/.test(text) ? 'Number' : 'String',
          value: String(text)
        }
      };
    }
    this.defaultExportParams = {
      getCustomContentBelowRow: (params: any) => {
        return [
          {
            cells: [
              cell('', 'header'),
              cell('Acquired Date', 'header'),
              cell(' ', 'header'),
              cell(' ', 'header'),
              cell(' ', 'header'),
              cell(' ', 'header'),
              cell(' ', 'header'),
            ]
          }
        ].concat(
          ...(params.node.detailNode.data.lotDetail).map((record: any) => {
            let rowData: TableColumn[] = [];
            let lotsToMove: string = '';
            let emv: string = '';
            this.store.select(selectPositionLotTableData).pipe(take(1)).subscribe((data) => {
              rowData = data;
            });
            const pos = rowData.find((position: TableColumn) => position['Symbol'] === params.node.detailNode.data['Symbol']);
            if (pos !== undefined) {
              const lot = pos['lotDetail'].find((lotData: TableColumn) => lotData['lotId'] === record['lotId']);
              if (lot !== undefined) {
                lotsToMove = lot['lotsToMove'];
                emv = this.emvLogic({lotsToMove:lotsToMove}, params.node) ?? '';
              }
            }
            let Holdingvalue = record.holdingPeriod ?? record.data["Holding Period"];
            let HoldingData= this.decimalPipe.transform(record.lotQuantity, '1.0-6') + ' (' + Holdingvalue.toLowerCase() + '-term' + ')';
            let costValue= record.costBasis ?? record.data["Cost Basis"];
            let costData : any = this.currencyPipe.transform(costValue);
            let lotsToMoveFormatted = (lotsToMove === undefined || this.costBasisMethod !== 'None' && this.costBasisMethod !== undefined) ? '' :this.returnFormattedSharesValue(lotsToMove);
            let res: ExcelRow[]= [{
              cells : [
                cell('', 'body'),
                cell(record.acquiredDate ?? record.data["Acquired date"], 'body'),
                cell(HoldingData, 'body'),
                cell(record.currentPriceShare ?? params.node.detailNode.data["Current price/share"], 'body'),
                cell(costData, 'body'),
                cell(lotsToMoveFormatted, 'body'),
                cell(emv === '$0.00' ? '' : emv, 'body')
            ]}];
            return res;
          }),
          [] as ExcelRow[],
          {
            cells: []
          }
        );
      },
      columnWidth: 165
    };

    this.excelStyles = [
      {
        id: "cell",
        font: { color: 'black', },
        alignment: { vertical: 'Center', horizontal: 'Center', wrapText: true },
        borders:
        {
          borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1, }
        }
      },
      {
        id: "body",
        font: { color: 'black', },
        alignment: { vertical: 'Center', horizontal: 'Center' },
        borders:
        {
          borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1, }
        }
      },
      {
        id: 'header',
        font: { bold: true },
        interior: { color: '#F1F1F1', pattern: 'Solid', patternColor: 'white' },
        alignment: { vertical: 'Center', horizontal: 'Center', },
        borders:
        {
          borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1, }
        }
      }];
  }
}
